import React from 'react';
import { getConfig } from '../../../utils/config';

function Table() {

    return (
        <div className=' text-black font-normal text-[17px] leading-7 overflow-x-auto pb-2'>
            <table className='tncTable min-w-[600px]'>
                <thead>
                    <tr>
                        <th >No of Years Served</th >
                        <th >Discount</th >
                        <th >No of Units</th >
                    </tr>
                </thead>
                <tbody>
                    <tr >
                        <td >2 - 5 years</td>
                        <td >3%</td>
                        <td >{`1 (One) Apartment/Plot/Retail Shop`}</td>
                    </tr>
                    <tr>
                        <td >5.01 - 10 years</td>
                        <td >4%</td>
                        <td >{`1 (One) Apartment/Plot/Retail Shop`}</td>
                    </tr>
                    <tr>
                        <td >10.01 years+</td>
                        <td >5%</td>
                        <td >{`1 (One) Apartment/Plot/Retail Shop`}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default Table;
